<template>
  <div class="bg">
    <el-tabs v-model="activeName">
      <!-- <el-tab-pane label="用户同步" name="1"
        ><div class="select bgcf p15 mb15">
          <ul>
            <li>
              <em>选择学校：</em>
              <el-select
                v-model="search.schoolId"
                size="small"
                filterable
                placeholder="请选择"
                clearable
                v-if="search.schoolShow"
              >
                <el-option
                  v-for="item in search.schoolList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-tag v-else>{{ search.schoolName }}</el-tag>
            </li>
          </ul>
        </div>
        <div>
          <div class="bd bgcf p15 mb15" v-if="userModule.userType != 'School'">
            <el-tag type="danger"
              >系统级同步：同步系统级的数据，不按照区和校区分，同步授权的所有数据</el-tag
            >
            <br />
            <el-button type="primary" size="small" @click="sync_data('Term', false)"
              >同步学期</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('Subject', false)"
              >同步学科</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('Region', false)"
              >同步区</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('Bureau', false)"
              >同步教育局</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('School', false)"
              >同步学校</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('UserBureau', false)"
              >同步集团用户</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('DeleteUser', false)"
              >删除用户</el-button
            >
          </div>
          <div class="bd bgcf p15 mb15">
            <el-tag type="danger"
              >校级同步：同步校级的数据，需要先选择学校，才能执行同步</el-tag
            >
            <br />
            <el-button type="primary" size="small" @click="sync_data('Department', true)"
              >同步学校部门</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('Class', true)"
              >同步班级</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('Teacher', true)"
              >同步教师</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('ClassTime', true)"
              >同步课时</el-button
            >
            <el-button type="primary" size="small" @click="sync_data('ClassTable', true)"
              >同步课表</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="sync_data('TeacherCourse', true)"
              >同步任课</el-button
            >
          </div>
          <div class="mb15 df" style="justify-content: space-between">
            <el-input
              type="textarea"
              :rows="20"
              v-model="data.result"
              placeholder="显示同步结果"
              v-loading="data.loading"
            ></el-input>
          </div></div
      ></el-tab-pane> -->
      <el-tab-pane label="目录同步" name="2">
        <div class="fl" style="padding-bottom: 15px">
          <el-button type="primary" size="small" @click="sync_catalog1()"
            >同步基础数据</el-button
          >
          <el-button type="primary" size="small" @click="sync_catalog2()"
            >同步版本</el-button
          >
        </div>
        <div class="fr">
          <el-button type="primary" size="small" @click="cache()">缓存目录数据</el-button>
        </div>

        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column prop="text" label="版本名称"> </el-table-column>
          <el-table-column label="操作"
            ><template slot-scope="scope">
              <el-button @click="syncChapter(scope.row)" type="text" size="small"
                >同步章节</el-button
              >
            </template></el-table-column
          >
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="选择版本" :visible.sync="dialogVisible" width="50%">
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <div style="margin: 15px 0"></div>
      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="city in cities" :label="city.id" :key="city.id">{{
          city.versionName
        }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveVersion()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import role from "../../mixins/role.js";
import date from "../../mixins/date.js";
export default {
  data() {
    return {
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      tableData: [],
      dialogVisible: false,
      activeName: "1",
      search: {
        schoolShow: true,
        areaId: "",
        schoolId: "",
        schoolList: [],
      },
      data: {
        loading: false,
        result: "",
      },
      system: [],
    };
  },
  mixins: [role, date],
  watch: {},
  mounted() {
    this.loadVersion();
    this.load_school();
  },
  methods: {
    cache() {
      this.$ajax.post("/common/catalog/task/cache").then((res) => {
        this.$message.success("缓存更新成功");
      });
    },
    loadVersion() {
      this.$ajax.post("/common/catalog/task/load/version").then((res) => {
        // this.getSystem();
        this.tableData = res;
      });
    },
    saveVersion() {
      this.dialogVisible = false;
      let v = this.cities.filter((el) => this.checkedCities.includes(el.id));
      this.$ajax
        .post("/common/catalog/task/save/version", v, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          // this.getSystem();
          this.loadVersion();
        });
    },
    syncChapter(v) {
      this.$ajax
        .post("/common/catalog/task/sync/chapter", { versionId: v.node })
        .then((res) => {
          // this.getSystem();
          this.$message.success("同步成功");
        });
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities.map((el) => el.id) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    init: function () {
      this.loadVersion();
    },
    sync_catalog1() {
      this.$ajax.post("/common/catalog/task/sync/data", {}).then((res) => {
        // this.getSystem();
        this.$message.success("基础数据同步成功");
      });
    },
    sync_catalog2() {
      this.$ajax.post("/common/catalog/task/sync/version", {}).then((res) => {
        this.cities = res.versionList;
        this.dialogVisible = true;
        this.checkedCities = res.selectList;
      });
    },
    saveSys(id, v) {
      this.$ajax
        .post("/server/config/save/data", { configId: id, configValue: v })
        .then((res) => {
          // this.getSystem();
          this.$message.success("保存成功");
        });
    },
    getSystem() {
      this.$ajax.post("/server/config/load/data", {}).then((res) => {
        this.system = res;
      });
    },
    sync_statistics() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$ajax.post("/server/index/check/table", {}).then((res) => {
        loading.close();
        this.$message.success("初始化成功");
      });
    },
    sync_data: function (type, check) {
      if (check && !this.search.schoolId) {
        this.$message.error("请先选择学校");
        return;
      }
      this.data.loading = true;
      this.$ajax
        .post("/server/sync/data", {
          schoolId: this.search.schoolId,
          type: type,
        })
        .then((res) => {
          this.data.result = res;
          this.data.loading = false;
        });
    },
    load_school: function () {
      this.$ajax.post("/common/load/school", {}).then((res) => {
        this.search.schoolList = res;
        this.search.gradeList = [];
        this.search.classList = [];
        this.search.gradeId = "";
        this.search.classId = "";
      });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/page/manage/sync.vue